module.exports = __webpack_public_path__ + "img/流体力学4_2_4.3594f470.jpg";